export const MaxFileSizePerDocumentMB = 5; // 5MB
export const MaxFileSizePerDocumentBytes = MaxFileSizePerDocumentMB * 1024 * 1024;
export const DOCS_MAX_HELP_TIME = 150; // seconds
export const DOCS_MAX_TIME_PERFILE_SECONDS = 300; // 5 minutes per file
export const DOCS_MAX_TAKE_PHOTO_TIME = 180; // seconds
export const DOCS_WARNING_TIME = 90; // seconds
